module.exports = __webpack_public_path__ + "img/img5.7387bd50.png";